import React from 'react';
import { InputNumber, InputNumberProps } from 'primereact/inputnumber';

export type Props = InputNumberProps & {
  id: string;
  placeholder: string;
  usePlaceholderAsLabel?: boolean;
  helpText?: string;
  helpTextClassName?: string;
  pFieldClassName?: string;
};

export const NumberField: React.FC<Props> = ({
  id,
  placeholder,
  helpText,
  helpTextClassName = '',
  usePlaceholderAsLabel,
  pFieldClassName = '',
  ...otherProps
}) => {
  let helpElement;
  if (helpText) {
    helpElement = <small className={`${helpTextClassName}`}>{helpText}</small>;
  } else {
    helpElement = <React.Fragment />;
  }

  if (usePlaceholderAsLabel) {
    return (
      <div className={`p-field ${pFieldClassName}`}>
        <label htmlFor={id}>{placeholder}</label>
        <InputNumber id={id} {...otherProps} showButtons={true} />
        {helpElement}
      </div>
    );
  }

  return (
    <div className={`p-field ${pFieldClassName}`}>
      <InputNumber id={id} placeholder={placeholder} {...otherProps} showButtons={true} />
      {helpElement}
    </div>
  );
};
